<ng-container [formGroup]="formGroup">
  <p-dropdown
    #muDropDown
    appRegisterValidator
    [id]="field"
    [name]="field"
    [styleClass]="styleClass"
    [formControlName]="field"
    [placeholder]="'form.placeholder.' + field.split('Dynamic')[0] | translate"
    [options]="optionList"
    [filter]="filter"
    [filterBy]="filterBy"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [showClear]="showClear"
    [emptyFilterMessage]="
      emptyFilterMessage
        ? ('form.dropDown.' + (!muDropDown.filterValue || muDropDown.filterValue === '' ? 'empty' : 'notFound') + '.pointId' | translate)
        : ''
    "
    (onShow)="setPosition(); validatorService?.scrollToSelected(changeDetectorRef, formGroup, field, optionList)"
    (onHide)="validatorService?.validateControl(formGroup, field, changeDetectorRef)"
    [ngClass]="{ 'mu-form-editable-mask': editableMask, 'mu-form-dropdown-top': positionTop }"
    (click)="editableMask = false"
  >
    <ng-content></ng-content>
  </p-dropdown>
</ng-container>
